/**
 * Módulos de la aplicación cuyo acceso puede activar/desactivar el admin por
 * empresa. Cada módulo se corresponde con un campo booleano de `Company` y con
 * un conjunto de páginas del área de usuario.
 */
export const AppModuleEnum = {
  IA_VALIDATION: 'iaValidation',
  BENCHMARK: 'benchmark',
  TENDER: 'tender',
  SMART_CONNECT: 'smartConnect',
  POOLING: 'pooling',
  CONTROL_DOCUMENT: 'controlDocument',
} as const

export type AppModule = (typeof AppModuleEnum)[keyof typeof AppModuleEnum]

/** Campo de `Company` que guarda el acceso de cada módulo */
export const MODULE_ACCESS_FIELD = {
  [AppModuleEnum.IA_VALIDATION]: 'iaValidationAccess',
  [AppModuleEnum.BENCHMARK]: 'benchmarkAccess',
  [AppModuleEnum.TENDER]: 'tenderAccess',
  [AppModuleEnum.SMART_CONNECT]: 'smartConnectAccess',
  [AppModuleEnum.POOLING]: 'poolingAccess',
  [AppModuleEnum.CONTROL_DOCUMENT]: 'controlDocumentAccess',
} as const satisfies Record<AppModule, string>

export type ModuleAccessField =
  (typeof MODULE_ACCESS_FIELD)[keyof typeof MODULE_ACCESS_FIELD]

/** Acceso de la empresa a cada módulo, tal y como se guarda en `Company` */
export type ModuleAccess = Record<ModuleAccessField, boolean>

/** `select` de prisma con todos los campos de acceso */
export const MODULE_ACCESS_SELECT = Object.fromEntries(
  Object.values(MODULE_ACCESS_FIELD).map(field => [field, true]),
) as Record<ModuleAccessField, true>

export function hasModuleAccess(access: ModuleAccess, module: AppModule) {
  return access[MODULE_ACCESS_FIELD[module]]
}
